// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { DefaultConfig } from '../../settings/config'
import ToastMessage from '../../components/toast-messages'
import toast from 'react-hot-toast'
import axios from "axios"
import { ApiUrls } from '../../utility/ApiUrls'
import GlobalVariable from '../../settings/global'
import CryptoJS from "crypto-js"

const baseApiUrl = GlobalVariable.BASE_API_URL
let getUserCall = false
const chunkSize = 1048576 * 10
const paginateArray = (array, perPage, page) => array.slice((page - 1) * perPage, page * perPage)
const sorter = DefaultConfig().sorter

const getToken = () => {
  const expiryTimestamp = localStorage.getItem('tokenExpiry')
  if (!expiryTimestamp) {
    return false
  }
  const now = new Date().getTime()
  if (now > parseInt(expiryTimestamp, 10)) {
    return false
  }

  return true
}

let callUiConfiguration = false
let count = 0

const getUserApiCall = () => {
  axios.get(`${GlobalVariable.hostpath}api/Common/GetUIConfiguration`)
    .then((res) => {
      const result = res.data
      callUiConfiguration = false
      if (result) {
        const data = result.data
        if (data) {
          const azureAdB2C = data.azureAdB2C
          const merchantOne = data.merchantOne
          const JsScriptData = data.jsScriptData
          azureAdB2C['apiUrl'] = GlobalVariable.hostpath
          azureAdB2C['hostname'] = window.location.origin
          localStorage.setItem('azureAdB2C', JSON.stringify(azureAdB2C))
          localStorage.setItem('merchantOne', JSON.stringify(merchantOne))
          localStorage.setItem('JsScriptData', JSON.stringify(JsScriptData))
          const expiryTimestamp = new Date().getTime() + (data.expiryTime * 60 * 1000)
          localStorage.setItem('expiryTime', expiryTimestamp)
          const localStorageToken = localStorage.getItem('token')
          axios.get(`${GlobalVariable.hostpath}api/User/GetUser`, {
            headers: { Authorization: `Bearer ${localStorageToken}` }
          }).then((res) => {
            const userData = res.data
            if (userData.success) {
              if (userData.data) {
                if (userData.data.isResetPassword === true) {
                  toast(t => (<ToastMessage t={t} message={"Your password has been changed successfully. Please Login..."} status={"success"} />))
                  setTimeout(() => {
                    localStorage.clear()
                    window.location.reload()
                  }, 3000)
                } else {
                  // const cookies = new Cookies()
                  // cookies.set('CustomClaims', res.headers["x-set-cookie"], { path: '/' })
                  // localStorage.setItem('userData', btoa(JSON.stringify(userData.data)))

                  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(userData.data), DefaultConfig().SECRET_KEY).toString()
                  localStorage.setItem('userData', encrypted)
                }
              }
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
              localStorage.clear()
              window.location.reload()
            }
          }).catch((error) => {
            const errorresponse = error.response
            const azureAdB2C = localStorage.getItem('azureAdB2C')
            if (errorresponse) {
              const status = errorresponse.status
              if (status === 403 || status === 401) {
                localStorage.clear()
                window.location.reload()
              } else if (status === 406) {
                window.location.reload()
              } else if (status === 412) {
                const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}&id_token_hint=${localStorage.getItem('token')}`
                localStorage.clear()
                window.location.href = AzureB2CLogoutUrl
              } else if (status === 417 || status === 424) {
                if (count !== 2) {
                  count = count + 1
                }
                if ((count + 1) === 3) {
                  const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}&id_token_hint=${localStorage.getItem('token')}`
                  localStorage.clear()
                  window.location.href = AzureB2CLogoutUrl
                }
              } else {
                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                setTimeout(() => {
                  localStorage.clear()
                  window.location.reload()
                }, 2000)
              }
            }
          })
        }
      }
  }).catch((error) => {
    const errorresponse = error.response
    if (errorresponse) {
      const status = errorresponse.status
      if (status === 404) {
        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
      }
    }
  })
}

const apiCall = async (method, endpoint, data) => {
  // console.log(method, endpoint, data)
  const authAxios = DefaultConfig().authAxios
  const token = getToken()
  if (!token && !callUiConfiguration) {
    callUiConfiguration = true
    // getUserApiCall()
  }
  if (method === 'get') {
    return await authAxios.get(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'post') {
    return await authAxios.post(endpoint, data)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'patch') {
    return await authAxios.patch(endpoint, data)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'delete') {
    return await authAxios.delete(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  }
}

export const setStoreMenuData = createAsyncThunk("appCommonReducers/setStoreMenuData", async (dmenuData) => {
  return dmenuData
})

// Get Employee Dashboard WOrkorders based on pagination
export const GetUsers = createAsyncThunk("appCommonReducers/GetUsers", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUsers}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const allUsers = []
    resultData.forEach((element) => {
      allUsers.push({ userId: element.id, name: `${element.firstName} ${element.lastName}`, email: element.email, companyId: element.companyId, status: element.isActive ? 'Active' : 'InActive' })
    })
    return {
      data: allUsers,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllRoles = createAsyncThunk("appCommonReducers/GetAllRoles", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllRoles}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserRoles = createAsyncThunk("appCommonReducers/GetUserRoles", async (uid) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUserRoles}?userId=${uid}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const SaveUserRoles = createAsyncThunk("appCommonReducers/SaveUserRoles", async (rdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.SaveUserRoles}?userId=${rdata.userId}`
  const data = rdata.data
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const displayMenu = createAsyncThunk("appCommonReducers/displayMenu", async (displayMenuBool) => {
  return displayMenuBool
})

export const getRefreshToken = createAsyncThunk("appCommonReducers/getRefreshToken", async () => {
  const method = 'get'
  const endpoint = `User/GetRefreshToken`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    localStorage.setItem("token", resultData.id_token)
    localStorage.setItem("refresh_token", resultData.refresh_token)
    getUserApiCall()
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetallDepartments = createAsyncThunk("appCommonReducers/GetallDepartments", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetallDepartments}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const allDepts = []
    resultData.forEach((item) => {
      allDepts.push({ value: item.id, label: item.name, name: item.name, id: item.id, isActive: item.isActive })
    })
    return {
      data: sorter("label", "asc", [...allDepts]),
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllDocumentCategories = createAsyncThunk("appCommonReducers/GetAllDocumentCategories", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllDocumentCategories}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const allDocTypes = []
    resultData.forEach((item) => {
      allDocTypes.push({ value: item.id, label: item.name, name: item.name, id: item.id, isActive: item.isActive, dId: item.departmentId })
    })
    return {
      data: sorter("label", "asc", [...allDocTypes]),
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllDocumentTypes = createAsyncThunk("appCommonReducers/GetAllDocumentTypes", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllDocumentTypes}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const allDocSubTypes = []
    resultData.forEach((item) => {
      allDocSubTypes.push({ value: item.id, label: item.name, name: item.name, id: item.id, isActive: item.isActive, dId: item.documentCategoryId })
    })
    return {
      data: sorter("label", "asc", [...allDocSubTypes]),
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetDocumentCategoryByDeptId = createAsyncThunk("appCommonReducers/GetDocumentCategoryByDeptId", async (dId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetDocumentCategoryByDeptId}?departmentId=${dId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const docTypes = []
    resultData.forEach((item) => {
      docTypes.push({ value: item.id, label: item.name, dId: item.departmentId, isActive: item.isActive })
    })
    return {
      data: docTypes,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllFiles = createAsyncThunk("appCommonReducers/GetAllFiles", async (obj) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetAllFiles}`
  const payload = obj.payload
  const wdata = obj.payload
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {
    const files = resultData.files
    return {
      data: files,
      perPage: wdata.pageSize,
      page: wdata.pageIndex,
      fileReference: wdata.fileReference,
      customLookUpID1: wdata.customLookUpID1,
      customLookUpID2: wdata.customLookUpID2,
      docTypeValue: wdata.docTypeValue,
      docSubTypeValue: wdata.docSubTypeValue,
      deptValue: wdata.deptValue,
      email: wdata.email,
      woId: wdata.woId,
      agentId: wdata.agentId,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const getFileData = createAsyncThunk("appCommonReducers/getFileData", async (wdata) => {
  return wdata
})

// Start File Upload, download and remove files
export const getUpdateFileData = createAsyncThunk("appCommonReducers/getUpdateFileData", async (newObj) => {
  return newObj
})

export const downloadChunk = createAsyncThunk("appCommonReducers/downloadChunk", async (values, thunkAPI) => {
  try {
    const authAxios = axios.create({
      baseURL: baseApiUrl,
      headers: {
        "Content-Range": `bytes ${values.offset}-${values.end}/${values.totalSize}`,
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      withCredentials: true
    })
    const response = await authAxios.get(`FileUpload/GetFileContentByFileId?fileId=${values['fileId']}`)
    const resData = response.data
    if (resData.success) {
      const respData = resData.data
      return respData
    } else {
      thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
      toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
    }
  } catch (error) {
    console.log("error", error)
    thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
  }
})

export const getOpenFile = createAsyncThunk("appCommonReducers/getOpenFile", async (file, thunkAPI) => {
  thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
  const authAxios = DefaultConfig().authAxios
  if (authAxios) {
    const encodedGuid = encodeURIComponent(file?.id)
    const returnData = await authAxios.get(`File/PreviewDocument?fileReferenceNumber=${encodedGuid}&fileId=${file?.fileId ? file?.fileId : 0}`)
    .then(async(response) => {
      const resultData = response.data
      if (resultData) {
        if (resultData.success) {
          const respData = resultData.data
          if (respData) {
            if (respData.content) {
              const fileName = respData.fileName
              const contentType = respData.contentType
              const content = respData.content
              if (respData.contentLength) {
                const totalSize = Number(respData.contentLength)
                const chunkCount = totalSize % chunkSize === 0 ? totalSize / chunkSize : Math.floor(totalSize / chunkSize) + 1
                const chunks = []
                let offset = 0
                let counter = 1
      
                while (offset < totalSize) {
                  const end = Math.min(offset + chunkSize, totalSize) - 1
                  const respayload = await thunkAPI.dispatch(downloadChunk({ offset, end, totalSize, fileId }))
                  const chunk = respayload.payload
      
                  chunks.push(chunk)
                  offset += chunkSize
                  if (counter === chunkCount) {
                    thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
                  } else {
                    thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
                  }
                  counter++
                }
      
                if ((fileName.includes('.pdf') || fileName.includes('.PDF'))) {
                  //
                } else {
                  const blobChunks = []
                  // Fetch each chunk and push it to the array
                  for (const chunk of chunks) {
                    const response = await fetch(`data:application/octet-stream;base64,${chunk}`)
                    const blob = await response.blob()
                    blobChunks.push(blob)
                  }
          
                  // Convert the Uint8Array to a Blob
                  const concatenatedBlob = new Blob(blobChunks, { type: contentType })
                  // Generate download URL
                  const downloadUrl = URL.createObjectURL(concatenatedBlob)
                  // Initiate a download by creating an anchor element and programmatically clicking it
                  const link = document.createElement('a')
                  link.href = downloadUrl
                  link.download = fileName
                  link.style.display = 'none'
                  document.body.appendChild(link)
                  link.click()
                  document.body.removeChild(link)
                  URL.revokeObjectURL(downloadUrl)
                }
              }
              
              return {
                data: { fileName, contentType, fileContent: '', chunks: [content], fileName, message: '' },
                tokenExp: false
              }
            } else {
              return {
                data: { chunks: [], message: respData?.errorMessage },
                tokenExp: false
              }
            }
          } else {
            return {
              data: { chunks: [], message: resultData?.errorMessage },
              tokenExp: false
            }
          }
        } else {
          if (resultData.errorMessage) {
            toast(t => (<ToastMessage t={t} message={resultData.errorMessage} status={"danger"} />))
          } else {
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
          }
          thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
          return ''
        }
      }
    }).catch((error) => {
      const errorresponse = error.response
      if (errorresponse) {
        const status = errorresponse.status
        if (status === 403) {
          return ''
        } else if (status === 406) {
          toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
          return ''
        } else if (status === 419) {
          if (!getUserCall) {
            getUserCall = true
            toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
            return ''
          }
        } else if (status === 401) {
          localStorage.clear()
          window.location.reload()
        } else {
          // const error = errorresponse.data.error
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
          return ''
        }
      }
    })
    return returnData
  } else {
    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
  }
})

export const getFailedFileData = createAsyncThunk("appCommonReducers/getFailedFileData", async (newObj) => {
  return newObj
})

export const uploadCompleted = createAsyncThunk("appCommonReducers/uploadCompleted", async ({ blocksData, values }, thunkAPI) => {
  try {
    const authAxios = axios.create({
      baseURL: baseApiUrl,
      headers: {
        "X-File-Name": values['filename'],
        "X-FilereferenceId": values['guid'],
        "X-DocumentType": values.fileDto[0].documentType,
        "X-DocumentSubType": values.fileDto[0].documentSubType,
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      withCredentials: true
    })
    const response = await authAxios.post(`FileUpload/CompleteUpload`, blocksData)
    const resData = response.data
    if (resData.success) {
      const newObj = {}
      newObj['floader'] = true
      newObj['tokenExp'] = false
      newObj['fileData'] = resData.data

      newObj['beginingOfTheChunk'] = 0
      newObj['endOfTheChunk'] = chunkSize
      newObj['blockData'] = []
      return newObj
    } else {
      thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
      toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
    }
  } catch (error) {
    thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
  }
})

// export const FileUploadChunks = createAsyncThunk("appCommonReducers/FileUploadChunks", async (values, thunkAPI) => {
//   if (values.fileDto.length > 0) {
//     // const chunk = values['_file'].slice(values.beginingOfTheChunk, values.endOfTheChunk)
//     const formData = new FormData()
//     formData.append('file', values['_file'])
//     try {
//       const authAxios = axios.create({
//         baseURL: baseApiUrl,
//         headers: {
//           "X-Total-Chunks": values['chunkCount'],
//           "X-Chunk-Number": values['counter'],
//           "X-File-Name": (values['filename']),
//           "X-File-Size": values['fileSize'],
//           "X-Chunk-Size": values['chunkSize'],
//           "X-DocumentType": values.fileDto[0].documentType,
//           "X-DocumentSubType": values.fileDto[0].documentSubType,
//           "X-WoId": values.fileDto[0].woId,
//           "X-AgentId": values.fileDto[0].agentId,
//           "X-CustomLookUpID1": values.fileDto[0].customLookUpID1,
//           "X-CustomLookUpID2": values.fileDto[0].customLookUpID2,
//           "X-IsExternal": values.fileDto[0].isExternal,
//           "X-FilereferenceId": values['guid'],
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${localStorage.getItem('token')}`
//         },
//         withCredentials: true
//       })
//       const response = await authAxios.post(`FileUpload/FileUploadChunks`, formData)
//       const respdata = response.data
//       if (respdata.success) {
//         // if (values['counter'] === values['chunkCount']) {
//         //   const blocksData = values.blockData
//         //   blocksData.push(respdata.data)
//         //   const respayload = await thunkAPI.dispatch(uploadCompleted({ blocksData, values }))
//         //   const uploadedData = respayload.payload
//         //   return uploadedData
//         // } else {
//         //   const blocksData = values.blockData
//         //   blocksData.push(respdata.data)
//         //   const beginingOfTheChunk = values['endOfTheChunk']
//         //   const endOfTheChunk = values['endOfTheChunk'] + values['chunkSize']
//         //   const newObj = {}
//         //   newObj['beginingOfTheChunk'] = beginingOfTheChunk
//         //   newObj['endOfTheChunk'] = endOfTheChunk
//         //   newObj['blockData'] = blocksData
//         //   return newObj
//         // }
//         return respdata.data
//       } else {
//         // console.log("Error Occurred:", data.errorMessage)
//         thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
//         toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
//         return ''
//       }
//     } catch (error) {
//       thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
//       // console.log("error", error)
//       toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
//       return ''
//     }
//   }
// })

// export const saveFileUploads = createAsyncThunk("appCommonReducers/saveFileUploads", async (values, thunkAPI) => {
//   if (values.fileDto.length > 0) {
//     const _file = values.fileDto[0].file
//     // console.log(_file.size, 1048576 * 1024)
//     if (_file.size <= 1048576 * 1024) {
//       const chunkCount = _file.size % chunkSize === 0 ? _file.size / chunkSize : Math.floor(_file.size / chunkSize) + 1
//       thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: true, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
  
//       const fileSize = _file.size
//       const filename = _file.name

//       values['chunkSize'] = chunkSize
//       values['_file'] = _file
//       values['chunkCount'] = chunkCount
//       values['fileSize'] = fileSize
//       values['filename'] = (filename)

//       function generateGUID() {
//         return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
//           const r = (Math.random() * 16) | 0
//           const v = c === 'x' ? r : (r & 0x3) | 0x8
//           return v.toString(16)
//         })
//       }

//       values['guid'] = generateGUID()

//       values['beginingOfTheChunk'] = 0
//       values['endOfTheChunk'] = chunkSize
//       values['blockData'] = []

//       values['counter'] = 1
//       const respayload = await thunkAPI.dispatch(FileUploadChunks(values))
//       const fileUploadData = respayload.payload
//       if (fileUploadData) {
//         thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
//         // console.log(fileUploadData)
//         return {
//           data: fileUploadData,
//           spinner: fileUploadData.floader,
//           tokenExp: fileUploadData.tokenExp
//         }
//       }

//       // for (let i = 0; i < chunkCount; i++) {
//       //   values['counter'] = i + 1
//       //   const respayload = await thunkAPI.dispatch(FileUploadChunks(values))
//       //   const fileUploadData = respayload.payload
//       //   if ((i + 1) === chunkCount) {
//       //     if (fileUploadData) {
//       //       thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
//       //       // console.log(fileUploadData)
//       //       return {
//       //         data: fileUploadData.fileData,
//       //         spinner: fileUploadData.floader,
//       //         tokenExp: fileUploadData.tokenExp
//       //       }
//       //     } else {
//       //       break
//       //     }
//       //   } else {
//       //     if (fileUploadData) {
//       //       thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: true, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
//       //       values['beginingOfTheChunk'] = fileUploadData.beginingOfTheChunk
//       //       values['endOfTheChunk'] = fileUploadData.endOfTheChunk
//       //       values['blockData'] = fileUploadData.blockData
//       //     } else {
//       //       break
//       //     }
//       //   }
//       // }
//     } else {
//       toast(t => (<ToastMessage t={t} message={"FIle upload does not exceed more than 1 GB"} status={"danger"} />))
//     }
//   }
// })

export const FileUploadChunks = createAsyncThunk("appCommonReducers/FileUploadChunks", async (values, thunkAPI) => {
  if (values.fileDto.length > 0) {
    // const chunk = values['_file'].slice(values.beginingOfTheChunk, values.endOfTheChunk)
    const formData = new FormData()
    formData.append('file', values['_file'])
    try {
      const headers1 = {
        "X-Total-Chunks": values['chunkCount'],
        "X-Chunk-Number": values['counter'],
        "X-File-Name": (values['filename']),
        "X-File-Size": values['fileSize'],
        "X-Chunk-Size": values['chunkSize'],
        "X-DocumentType": values.fileDto[0].documentType,
        "X-DocumentSubType": values.fileDto[0].documentSubType,
        "X-WoId": values.fileDto[0].woId,
        "X-AgentId": values.fileDto[0].agentId,
        "X-CustomLookUpID1": values.fileDto[0].customLookUpID1,
        "X-CustomLookUpID2": values.fileDto[0].customLookUpID2,
        "X-IsExternal": values.fileDto[0].isExternal,
        "X-FilereferenceId": values.fileDto[0].guid,
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
      if (values.fileDto[0]?.fileIdExist) {
        headers1["X-File-FileId"] = values.fileDto[0].fileIdExist
      }
      const authAxios = axios.create({
        baseURL: baseApiUrl,
        headers: headers1,
        withCredentials: true
      })

      const response = await authAxios.post((`FileUpload/FileUploadChunks`), formData)
      const respdata = response.data
      if (respdata.success) {
        // if (values['counter'] === values['chunkCount']) {
        //   const blocksData = values.blockData
        //   blocksData.push(respdata.data.blockId)
        //   if (respdata.data?.blockId) {
        //     const respayload = await thunkAPI.dispatch(uploadCompleted({ blocksData, values }))
        //     const uploadedData = respayload.payload
        //     uploadCompleted['parseData'] = parseData
        //     return uploadedData
        //   } else {
        //     const newObj = {}
        //     const fileData = respdata.data
        //     fileData['doumentType'] = values.fileDto[0].documentType
        //     newObj['floader'] = true
        //     newObj['tokenExp'] = false
        //     newObj['fileData'] = fileData

        //     newObj['beginingOfTheChunk'] = 0
        //     newObj['endOfTheChunk'] = values['chunkSize']
        //     newObj['blockData'] = []
        //     newObj['parseData'] = parseData
        //     return newObj
        //   }
        // } else {
        //   const blocksData = values.blockData
        //   blocksData.push(respdata.data.blockId)
        //   const beginingOfTheChunk = values['endOfTheChunk']
        //   const endOfTheChunk = values['endOfTheChunk'] + values['chunkSize']
        //   const newObj = {}
        //   newObj['beginingOfTheChunk'] = beginingOfTheChunk
        //   newObj['endOfTheChunk'] = endOfTheChunk
        //   newObj['blockData'] = blocksData
        //   return newObj
        // }
        return respdata.data
      } else {
        thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        thunkAPI.dispatch(getFailedFileData({ filename: myDecodeURIComponent(values['filename']), showFail: true }))
        return ''
      }
    } catch (error) {
      thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
      toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
      return ''
    }
  }
})

export const saveFileUploads = createAsyncThunk("appCommonReducers/saveFileUploads", async (values, thunkAPI) => {
  if (values.fileDto.length > 0) {
    const _file = values.fileDto[0].file
    if (_file.size <= 1048576 * 1024) {
      const chunkCount = _file.size % chunkSize === 0 ? _file.size / chunkSize : Math.floor(_file.size / chunkSize) + 1
      thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: true, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
      const fileSize = _file.size
      const filename = _file.name ? _file.name : values['filename']
      values['chunkSize'] = chunkSize
      values['_file'] = _file
      values['chunkCount'] = chunkCount
      values['fileSize'] = fileSize
      values['filename'] = (filename)

      values['beginingOfTheChunk'] = 0
      values['endOfTheChunk'] = chunkSize
      values['blockData'] = []

      for (let i = 0; i < chunkCount; i++) {
        values['counter'] = i + 1
        const respayload = await thunkAPI.dispatch(FileUploadChunks(values))
        const fileUploadData = respayload.payload
        if (fileUploadData) {
          thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
          thunkAPI.dispatch(getFailedFileData({ filename: (values['filename']), showFail: false }))
          return {
            data: fileUploadData,
            spinner: fileUploadData.floader,
            tokenExp: fileUploadData.tokenExp
          }
        } else {
          thunkAPI.dispatch(getFailedFileData({ filename: (values['filename']), showFail: true }))
          break
        }
        // if ((i + 1) === chunkCount) {
        //   if (fileUploadData) {
        //     thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
        //     thunkAPI.dispatch(getFailedFileData({ filename: (values['filename']), showFail: false }))
        //     return {
        //       data: fileUploadData.fileData,
        //       spinner: fileUploadData.floader,
        //       tokenExp: fileUploadData.tokenExp
        //     }
        //   } else {
        //     thunkAPI.dispatch(getFailedFileData({ filename: (values['filename']), showFail: true }))
        //     break
        //   }
        // } else {
        //   if (fileUploadData) {
        //     thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: true, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
        //     values['beginingOfTheChunk'] = fileUploadData.beginingOfTheChunk
        //     values['endOfTheChunk'] = fileUploadData.endOfTheChunk
        //     values['blockData'] = fileUploadData.blockData
        //   } else {
        //     break
        //   }
        // }
      }
    } else {
      toast(t => (<ToastMessage t={t} message={"FIle upload does not exceed more than 1 GB"} status={"danger"} />))
    }
  }
})

export const getClearMultiStatus = createAsyncThunk("appCommonReducers/getClearMultiStatus", async () => {
    return ''
})

export const getWoLoading = createAsyncThunk("appCommonReducers/getWoLoading", async () => {
  return ''
})

export const closeProgressModal = createAsyncThunk("appCommonReducers/closeProgressModal", async (value) => {
  return value
})

export const commonreducerSlice = createSlice({
  name: 'appCommonReducers',
  initialState: {
    usersData: null,
    uspiner: false,
    userRoleData: [],
    urspiner: false,

    adtspiner: false,
    deptData: [],
    adsspiner: false,
    docTypeData: [],
    docSubTypeData: [],
    dtdspiner: false,
    docTypeDepData: [],

    pSpinner: false,
    pallData: [],
    phallData: [],
    pdata: [],
    ptotalCount: 1,
    pperPage: 0,
    ppage: 1,

    fileData: {},
    floader: true,

    mfileData: null,
    mloader: true,
    mfileStatus: '',
    total: 0,
    counter: 0,
    progress: false,
    fileCount: 0,
    totalfilecount: [],

    fileStatus: '',
    fileExceed: false,
    chunksData: [],
    dmenuData: [],

    failedFileData: [],
    upCount: 0,
    msfileData: {},
    msloader: true
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getWoLoading.fulfilled, (state) => {
        state.phallData = []
        state.pdata = []
        state.ptotalCount = 1
      })
      .addCase(setStoreMenuData.fulfilled, (state, action) => {
        if (action.payload) {
          state.dmenuData = action.payload
        }
      })
      .addCase(getClearMultiStatus.fulfilled, (state) => {
        state.mfileData = null
      })
      .addCase(displayMenu.fulfilled, (state, action) => {
        state.displayMenuBool = action.payload
      })
      // start role management
      .addCase(GetUsers.fulfilled, (state, action) => {
        if (action.payload) {
          state.uspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.usersData = action.payload.data
        }
      })
      .addCase(GetUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userRoleData = action.payload.data
        }
      })
      .addCase(SaveUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
        }
      })
    // end role management

    .addCase(GetallDepartments.fulfilled, (state, action) => {
      if (action.payload) {
        state.adtspiner = action.payload.spinner
        state.tokenExp = action.payload.tokenExp
        state.deptData = action.payload.data
      }
    })
    .addCase(GetAllDocumentCategories.fulfilled, (state, action) => {
      if (action.payload) {
        state.adtspiner = action.payload.spinner
        state.tokenExp = action.payload.tokenExp
        state.docTypeData = action.payload.data
      }
    })
    .addCase(GetDocumentCategoryByDeptId.fulfilled, (state, action) => {
      if (action.payload) {
        state.dtdspiner = action.payload.spinner
        state.tokenExp = action.payload.tokenExp
        state.docTypeData = action.payload.data
      }
    })
    .addCase(GetAllDocumentTypes.fulfilled, (state, action) => {
      if (action.payload) {
        state.adsspiner = action.payload.spinner
        state.tokenExp = action.payload.tokenExp
        state.docSubTypeData = action.payload.data
      }
    })
    .addCase(saveFileUploads.fulfilled, (state, action) => {
        if (action.payload) {
          state.upCount = state.upCount + 1
          if (state.upCount === state.totalfilecount?.length) {
            state.progress = true
          }
          if (!action.payload.type) {
            state.floader = action.payload.spinner
            state.tokenExp = action.payload.tokenExp
            state.mfileData = action.payload.data
          } else {
            state.mloader = action.payload.spinner
            state.tokenExp = action.payload.tokenExp
            state.mfileData = action.payload.data
          }
        } else {
          state.upCount = state.upCount + 1
          if (state.upCount === state.totalfilecount?.length) {
            state.progress = true
          }
          state.mfileStatus = 'not count match'
          if (action.payload) {
            if (!action.payload.type) {
              state.floader = true
            } else {
              state.mloader = true
            }
          } else {
            state.fileExceed = true
          }
        }
      })
      .addCase(getFailedFileData.fulfilled, (state, action) => {
        if (action.payload) {
          let failedFileData = [...state.failedFileData]
          failedFileData.push({ filename: action.payload.filename, showFail: action.payload.showFail })
          failedFileData = failedFileData.filter((item, index, self) => index === self.findIndex(obj => obj.filename === item.filename && obj.showFail === item.showFail))
          state.failedFileData = failedFileData
        }
      })
      .addCase(closeProgressModal.fulfilled, (state, action) => {
        if (action.payload) {
          state.failedFileData = []
          state.progress = false
          state.upCount = 0
        }
      })
    // .addCase(saveFileUploads.fulfilled, (state, action) => {
    //   if (action.payload) {
    //     if (!action.payload.type) {
    //       state.floader = action.payload.spinner
    //       state.tokenExp = action.payload.tokenExp
    //       state.fileData = action.payload.data
    //     } else {
    //       state.mloader = action.payload.spinner
    //       state.tokenExp = action.payload.tokenExp
    //       state.mfileData = action.payload.data
    //     }
    //   } else {
    //     if (action.payload) {
    //       if (!action.payload.type) {
    //         state.floader = true
    //       } else {
    //         state.mloader = true
    //       }
    //     } else {
    //       state.fileExceed = true
    //     }
    //   }
    // })
    .addCase(getUpdateFileData.fulfilled, (state, action) => {
      if (action.payload) {
        state.total = action.payload.total
        state.counter = action.payload.counter
        state.progress = action.payload.progress
        state.fileCount = action.payload.fileCount
        state.totalfilecount = action.payload.totalfilecount
        state.fileStatus = action.payload.fileStatus
      }
    })
    .addCase(getOpenFile.fulfilled, (state, action) => {
      if (action.payload?.data) {
        state.chunksData = action.payload.data.chunks
      }
    })
    .addCase(GetAllFiles.fulfilled, (state, action) => {
      if (action.payload?.data) {
        const perPage = action.payload.perPage
        const page = action.payload.page
        const fileReference = action.payload.fileReference
        const deptValue = action.payload.deptValue
        const docTypeValue = action.payload.docTypeValue
        const docSubTypeValue = action.payload.docSubTypeValue
        const customLookUpID1 = action.payload.customLookUpID1
        const customLookUpID2 = action.payload.customLookUpID2
        const email = action.payload.email
        const woId = action.payload.woId
        const agentId = action.payload.agentId

        const docTypes = state.docTypeData
        const docSubTypes = state.docSubTypeData
        const departments =  state.deptData
        const arrayOfObjectsWithDates = action.payload.data
        for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
          const data = arrayOfObjectsWithDates[i]
          const findDocType = docTypes.find(find => find.value === data.documentTypeId)
          const findDocSubType = docSubTypes.find(find => find.value === data.documentSubTypeId)
          const findDep = departments.find(find => find.value === data.departmentId)
          data['documentType'] = findDocType ? findDocType.label : ''
          data['documentSubType'] = findDocSubType ? findDocSubType.label : ''
          data['department'] = findDep ? findDep.label : ''
        }
        state.pallData = arrayOfObjectsWithDates
        state.phallData = arrayOfObjectsWithDates

        if (deptValue) {
          state.phallData = state.phallData.filter(find => find.departmentId === Number(deptValue))
        }
        if (docTypeValue) {
          state.phallData = state.phallData.filter(find => find.documentTypeId === Number(docTypeValue))
        }
        if (docSubTypeValue) {
          state.phallData = state.phallData.filter(find => find.documentSubTypeId === Number(docSubTypeValue))
        }

        if (fileReference) {
          state.phallData = state.phallData.filter(find => ((find.fileReference && String(find.fileReference).toLowerCase().includes(fileReference.toLowerCase()))))
        }
        if (customLookUpID1) {
          state.phallData = state.phallData.filter(find => find.customLookUpID1 === customLookUpID1)
        }
        if (customLookUpID2) {
          state.phallData = state.phallData.filter(find => find.customLookUpID2 === customLookUpID2)
        }

        if (woId) {
          state.phallData = state.phallData.filter(find => find.woId === woId)
        }
        if (agentId) {
          state.phallData = state.phallData.filter(find => find.agentId === agentId)
        }
        if (email) {
          state.phallData = state.phallData.filter(find => ((find.userEmail && String(find.userEmail).toLowerCase().includes(email.toLowerCase()))))
        }

        state.phallData = state.phallData
        state.pdata = paginateArray(state.phallData, perPage, page)
        state.ptotalCount = state.phallData.length
        state.pperPage = perPage
        state.ppage = page
        state.pSpinner = action.payload.spinner
      }
    })
    .addCase(getFileData.fulfilled, (state, action) => {
      const perPage = action.payload.perPage
      const page = action.payload.page
      const sortname = action.payload.sortname
      const sortorder = action.payload.sortorder
      const fileReference = action.payload.fileReference
      const woId = action.payload.woId
      const agentId = action.payload.agentId
      const docTypeValue = action.payload.docTypeValue
      const docSubTypeValue = action.payload.docSubTypeValue
      const customLookUpID1 = action.payload.customLookUpID1
      const customLookUpID2 = action.payload.customLookUpID2
      const deptValue = action.payload.deptValue

      const email = action.payload.email
      state.phallData = JSON.parse(JSON.stringify(state.pallData))
      if (deptValue) {
        state.phallData = state.phallData.filter(find => find.departmentId === Number(deptValue))
      }
      if (docTypeValue) {
        state.phallData = state.phallData.filter(find => find.documentTypeId === Number(docTypeValue))
      }
      if (docSubTypeValue) {
        state.phallData = state.phallData.filter(find => find.documentSubTypeId === Number(docSubTypeValue))
      }
      if (fileReference) {
        state.phallData = state.phallData.filter(find => ((find.fileReference && String(find.fileReference).toLowerCase().includes(fileReference.toLowerCase()))))
      }
      if (customLookUpID1) {
        state.phallData = state.phallData.filter(find => ((find.fileReference && String(find.customLookUpID1).toLowerCase().includes(customLookUpID1.toLowerCase()))))
      }
      if (customLookUpID2) {
        state.phallData = state.phallData.filter(find => ((find.fileReference && String(find.customLookUpID2).toLowerCase().includes(customLookUpID2.toLowerCase()))))
      }
      if (woId) {
        state.phallData = state.phallData.filter(find => ((find.fileReference && String(find.woId).toLowerCase().includes(woId.toLowerCase()))))
      }
      if (agentId) {
        state.phallData = state.phallData.filter(find => find.agentId === agentId)
      }
      if (email) {
        state.phallData = state.phallData.filter(find => ((find.userEmail && String(find.userEmail).toLowerCase().includes(email.toLowerCase()))))
      }
      const sortData = sortorder ? sorter(sortname, sortorder, state.phallData) : state.phallData
      state.pdata = paginateArray(sortData, perPage, page)
      state.ptotalCount = sortData.length
      state.pperPage = perPage
      state.ppage = page
    })
  }
})
export const { handleAddtoCart } = commonreducerSlice.actions
export default commonreducerSlice.reducer
